import { createReducer } from '@reduxjs/toolkit';
import InitialState from './initial-state';
import externalApplications, {
  syncActions
} from '../actions/external-applications';
import * as UIActions from '../actions/ui';
import { jumpContext } from '../actions/contexts.action';
import { LOAD_STATES } from './common';
import { externalApplications as externalAppFixtures } from '../stubs/external-applications';

const reducer = createReducer(InitialState.externalApplications, (builder) => {
  builder.addCase(UIActions.logout.type, () => ({ ...InitialState.externalApplications }));
  builder.addCase(jumpContext.pending.type, () => ({ ...InitialState.externalApplications }));

  builder.addCase(externalApplications.listExternalApps.pending, state => ({
    ...state,
    externalApplicationList: {
      ...state.externalApplicationList,
      loadState: LOAD_STATES.initial,
      items: []
    }
  }));

  builder.addCase(externalApplications.listExternalApps.rejected, state => ({
    ...state,
    loadState: LOAD_STATES.failed
  }));

  builder.addCase(externalApplications.listExternalApps.fulfilled, (state, action) => {
    const { sortablePageable } = state.externalApplicationList;
    const sp = {
      ...sortablePageable,
      pageableDefinition: { ...action.payload }
    };
    return {
      ...state,
      externalApplicationList: {
        ...state.externalApplicationList,
        sortablePageable: sp,
        loadState: LOAD_STATES.done
      }
    };
  });

  builder.addCase(externalApplications.listExternalAppUsers.pending, state => {
    const { selectedExternalApplication: { externalApplicationName } } = state;
    return {
      ...state,
      externalApplicationUserList: {
        ...state.externalApplicationUserList,
        loadState: LOAD_STATES.initial,
        items: []
      },
      selectedUser: {
        ...externalAppFixtures.defaultExternalApplicationUser,
        externalApplicationName
      }
    };
  });

  builder.addCase(externalApplications.listExternalAppUsers.rejected, state => ({
    ...state,
    loadState: LOAD_STATES.failed
  }));

  builder.addCase(externalApplications.listExternalAppUsers.fulfilled, (state, action) => {
    const { sortablePageable } = state.externalApplicationList;
    const sp = {
      ...sortablePageable,
      pageableDefinition: { ...action.payload }
    };
    return {
      ...state,
      externalApplicationUserList: {
        ...state.externalApplicationUserList,
        sortablePageable: sp,
        loadState: LOAD_STATES.done
      }
    };
  });

  builder.addCase(syncActions.selectExternalApplication, (state, action) => ({
    ...state,
    selectedExternalApplication: action.payload
  }));

  builder.addCase(syncActions.selectExternalAppUser, (state, action) => ({
    ...state,
    selectedUser: action.payload
  }));

  builder.addCase(externalApplications.saveExternalAppUser.pending, state => ({
    ...state,
    loadState: LOAD_STATES.initial
  }));

  builder.addCase(externalApplications.saveExternalAppUser.rejected, (state, action) => ({
    ...state,
    loadState: LOAD_STATES.failed,
    userFormErrors: (action.payload as any)?.errors ?? []
  }));

  builder.addCase(externalApplications.saveExternalAppUser.fulfilled, state => ({
    ...state,
    selectedUser: externalAppFixtures.defaultExternalApplicationUser
  }));

  builder.addCase(syncActions.selectOrgnization, (state, action) => ({
    ...state,
    selectedOrgId: action.payload
  }));

  builder.addCase(syncActions.setStateToDefault, (state, action) => {
    const { selectedExternalApplication: { externalApplicationName } } = state;
    return {
      ...state,
      selectedUser: {
        ...action.payload,
        externalApplicationName
      }
    };
  });
});

export default reducer;
